import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteFavoriteExerciseSessionItem } from '../../../../api/diary-service';

const useDeleteFavoriteSessionItem = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteFavoriteExerciseSessionItem,
        onSuccess: () => {
            queryClient.invalidateQueries(['favorite-exercise-sessions']);
        }
    });
};

export default useDeleteFavoriteSessionItem;
